(function idleDeadline(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  const previousIdleDeadline = global.NewHomeSource.Modules.IdleDeadline;

  /**
   * @constructs NewHomeSource.Modules.idleDeadline
   */
  function IdleDeadline() {
    this.startTime = Date.now();
  }

  /**
   * @public
   * didTimeout: always false. Method exists to support the interface.
   */
  IdleDeadline.prototype.didTimeout = function didTimeout() {
    return false;
  };

  /**
  * @public
  * timeRemaining: amount of time available after the IdleDeadline was instanced.
  */
  IdleDeadline.prototype.timeRemaining = function timeRemaining() {
    return Math.max(0, 50 - (Date.now() - this.startTime));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  IdleDeadline.noConflict = function noConflict() {
    global.NewHomeSource.Modules.IdleDeadline = previousIdleDeadline;
    return IdleDeadline;
  };

  global.NewHomeSource.Modules.IdleDeadline = IdleDeadline;
}(window));
